/**
 * 大屏模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 省工商联组织概况-年份下拉
  {
    name: 'getOrgProfileYear',
    url: '/api/back-end-api/v1/member-screen/org-profile/year',
  },
  // 省工商联组织概况
  {
    name: 'getOrgProfile',
    url: '/api/back-end-api/v1/member-screen/org-profile',
  },
  // 省工商联组织发展情况
  {
    name: 'getOrgDevelopment',
    url: '/api/back-end-api/v1/member-screen/org-development',
  },
  // 省工商联组织基础情况
  {
    name: 'getOrgBaseInfo',
    url: '/api/back-end-api/v1/member-screen/org-base-info',
  },
  // 省工商联会员发展情况
  {
    name: 'getMemberDevelopment',
    url: '/api/back-end-api/v1/member-screen/member-development',
  },
  // 省工商联会员数前五城市
  {
    name: 'getMemberTopFive',
    url: '/api/back-end-api/v1/member-screen/member-top-five',
  },
  // 省工商联会员增速前三城市
  {
    name: 'getMemberGrowthTopThree',
    url: '/api/back-end-api/v1/member-screen/member-growth-top-three',
  },
  // 各地市近3年会员变化情况下拉框
  {
    name: 'getMemberChangeThreeYearsCity',
    url: '/api/back-end-api/v1/member-screen/member-change-three-years-city',
  },
  // 各地市近3年会员变化情况
  {
    name: 'getMemberChangeThreeYears',
    url: '/api/back-end-api/v1/member-screen/member-change-three-years',
  },
  // 市、县工商联编制人数情况-城市下拉框
  {
    name: 'getCityEPersonCity',
    url: '/api/back-end-api/v1/member-screen/city-e-person/city',
  },
  // 市、县工商联编制人数情况
  {
    name: 'getCityEPerson',
    url: '/api/back-end-api/v1/member-screen/city-e-person',
  },
  // 全国“五好”县级工商联
  {
    name: 'getNationalFiveGood',
    url: '/api/back-end-api/v1/member-screen/national-five-good',
  },
  // 广东省“五好”县级工商联
  {
    name: 'getProvincesFiveGood',
    url: '/api/back-end-api/v1/member-screen/provinces-five-good',
  },
  // 各地级以上市近3年镇街商会变化情况-城市下拉框
  {
    name: 'getCocChangeThreeYearCity',
    url: '/api/back-end-api/v1/member-screen/coc-change-three-year/city',
  },
  // 各地级以上市近3年镇街商会变化情况
  {
    name: 'getCocChangeThreeYear',
    url: '/api/back-end-api/v1/member-screen/coc-change-three-year',
  },
  // 全省工商联工作人员情况
  {
    name: 'getNationalStaffPosition',
    url: '/api/back-end-api/v1/member-screen/national-staff-position',
  },
  // 全省工商联工作人员情况-年份下拉框
  {
    name: 'getNationalStaffPositionYear',
    url: '/api/back-end-api/v1/member-screen/national-staff-position/year',
  },
  // 工商联执常委分类统计
  {
    name: 'getExecutiveCommitteeClassifiedStatistics',
    url: '/api/back-end-api/v1/member-screen/executive-committee-classified-statistics',
  },
  // 工商联执常委分类统计-城市下拉框
  {
    name: 'getExecutiveCommitteeClassifiedStatisticsCity',
    url: '/api/back-end-api/v1/member-screen/executive-committee-classified-statistics/city',
  },
  // 工商联执常委履职评价情况
  {
    name: 'getPerformanceEvaluationSituation',
    url: '/api/back-end-api/v1/member-screen/performance-evaluation-situation',
  },
  // 工商联执常委履职评价情况-年份下拉框
  {
    name: 'getPerformanceEvaluationSituationYear',
    url: '/api/back-end-api/v1/member-screen/performance-evaluation-situation/year',
  },
  // 工商联执常委履职评价情况-身份下拉框
  {
    name: 'getPerformanceEvaluationSituationIdentity',
    url: '/api/back-end-api/v1/member-screen/performance-evaluation-situation/identity',
  },
  // 工商联执常委基础信息-人名下拉框
  {
    name: 'getExecutiveOmmitteeBaseInfoPersonName',
    url: '/api/back-end-api/v1/member-screen/executive-ommittee-base-info/person-name',
  },
  // 工商联执常委基础信息-企业下拉框
  {
    name: 'getExecutiveOmmitteeBaseInfoEnterpriseName',
    url: '/api/back-end-api/v1/member-screen/executive-ommittee-base-info/enterprise-name',
  },
  // 工商联执常委基础信息
  {
    name: 'getExecutiveOmmitteeBaseInfo',
    url: '/api/back-end-api/v1/member-screen//executive-ommittee-base-info',
  },
  // 工商联执常委履职报告
  {
    name: 'getExecutiveCommitteePerformance',
    url: '/api/back-end-api/v1/member-screen/executive-committee-performance',
  },
  // 各地级以上市工商联会员入库情况分析-年份下拉框
  {
    name: 'getMembersAboveCityYear',
    url: '/api/back-end-api/v1/member-screen/members-above-city/year',
  },
  // 各地级以上市工商联会员入库情况分析
  {
    name: 'getMembersAboveCity',
    url: '/api/back-end-api/v1/member-screen/members-above-city',
  },
  // 工商联各级会员占比情况-年份下拉框
  {
    name: 'getAllLevelsMembersProportionYear',
    url: '/api/back-end-api/v1/member-screen/all-levels-members-proportion/year',
  },
  // 工商联各级会员占比情况
  {
    name: 'getAllLevelsMembersProportion',
    url: '/api/back-end-api/v1/member-screen/all-levels-members-proportion',
  },
  // 全省工商联商会党组织成立情况-年份下拉框
  {
    name: 'getProvinceCocPartyOrgEstablishmentSituationYear',
    url: '/api/back-end-api/v1/member-screen/province-coc-party-org-establishment-situation/year',
  },
  // 全省工商联商会党组织成立情况
  {
    name: 'getProvinceCocPartyOrgEstablishmentSituation',
    url: '/api/back-end-api/v1/member-screen/province-coc-party-org-establishment-situation',
  },
  // 全省工商联商会数量情况分析-年份下拉框
  {
    name: 'getProvinceCocAmountAnalysisYear',
    url: '/api/back-end-api/v1/member-screen/province-coc-amount-analysis/year',
  },
  // 全省工商联商会数量情况分析
  {
    name: 'getProvinceCocAmountAnalysis',
    url: '/api/back-end-api/v1/member-screen/province-coc-amount-analysis',
  },
  // 全省工商联商会层级情况分析-年份下拉框
  {
    name: 'getProvinceCocLevelSituationAnalysisYear',
    url: '/api/back-end-api/v1/member-screen/province-coc-level-situation-analysis/year',
  },
  // 全省工商联商会层级情况分析
  {
    name: 'getProvinceCocLevelSituationAnalysis',
    url: '/api/back-end-api/v1/member-screen/province-coc-level-situation-analysis',
  },
  // 全省工商联商会类型情况分析-年份下拉框
  {
    name: 'getProvinceCocTypeAnalysisYear',
    url: '/api/back-end-api/v1/member-screen/province-coc-type-analysis/year',
  },
  // 全省工商联商会类型情况分析
  {
    name: 'getProvinceCocTypeAnalysis',
    url: '/api/back-end-api/v1/member-screen/province-coc-type-analysis',
  },
  // 全省工商联发展情况
  {
    name: 'getMemberScreenRichtext',
    url: '/api/back-end-api/v1/member-screen/member-screen-richtext',
  },
  // 工商联商会基础信息
  {
    name: 'getChamberOfCommerceBaseInfo',
    url: '/api/back-end-api/v1/member-screen/chamber-of-commerce-base-info',
  },
  // 工商联商会基础信息
  {
    name: 'getPerformanceEvaluationSituationTableData',
    url: '/api/back-end-api/v1/member-screen/performance-evaluation-situation-table-data',
  },
  // 执常委企业健康
  {
    name: 'getExecutiveOmmitteeCompanyHealth',
    url: '/api/back-end-api/v1/member-screen/executive-ommittee-company-health',
  },
  // 执常委企业健康汇总
  {
    name: 'getExecutiveOmmitteeCompanyHealthTotal',
    url: '/api/back-end-api/v1/member-screen/executive-ommittee-company-health-total',
  },
  // 取消预警状态
  {
    name: 'updateExecutiveOmmitteeCompanyHealthDisable',
    url: '/api/back-end-api/v1/member-screen/executive-ommittee-company-health-disable',
    method: 'PUT',
    defaultConfig: {
      bodyParams: true,
    },
  },

];
